module.exports = __webpack_public_path__ + "img/cv.438a175f.jpg";